import React, { memo, ReactNode } from 'react'
import isNil from 'lodash/isNil'
import { formatRate } from 'utils/formatRate'

export interface IRateCurrencyProps {
  value?: number | null
  emptyPlaceholder?: ReactNode
  dataTest?: string
  prefix?: string
  maximumFractionDigits?: number
}

export const RateCurrency = memo<IRateCurrencyProps>(
  ({ dataTest, emptyPlaceholder, maximumFractionDigits = 2, prefix, value }) => (
    <span data-test={dataTest}>
      {isNil(value) ? emptyPlaceholder : formatRate(value, { maximumFractionDigits, prefix })}
    </span>
  )
)
